import React from 'react'
import { useTranslation } from 'react-i18next'
import './privacy.styles.scss'

const Policy = () => {
    const { t } = useTranslation();
    return (
        <div className='privacy' aria-label="Informativa sulla privacy">
            <h2 className="title">{t("policy.title")}</h2>
            <p className="paragraph">{t("policy.p1")}</p>
            <p className="paragraph">{t("policy.p2")}</p>
            <ol aria-label="Finalità del trattamento dati personali">
                <li><p className="paragraph">{t("policy.p2.p1")}</p></li>
                <li><p className="paragraph">{t("policy.p2.p2")}</p></li>
                <li><p className="paragraph">{t("policy.p2.p3")}</p></li>
                <li><p className="paragraph">{t("policy.p2.p4")}</p></li>
            </ol>
            <p className="paragraph">{t("policy.p3")}</p>
            <p className="paragraph">{t("policy.p4")}</p>
            <p className="paragraph">{t("policy.p5")}</p>
            <p className="paragraph">{t("policy.p6")}</p>
            <ol type="a" aria-label="Categorie di dati trattati">
                <li><p className="paragraph">{t("policy.p6.p1")}</p></li>
                <li><p className="paragraph">{t("policy.p6.p2")}</p></li>
                <li><p className="paragraph">{t("policy.p6.p3")}</p></li>
            </ol>
            <p className="paragraph">{t("policy.p7")}</p>
            <p className="paragraph">{t("policy.p8")}</p>
            <p className="paragraph">{t("policy.p9")}</p>
            <ol type="a" aria-label="Diritti dell’interessato">
                <li><p className="paragraph">{t("policy.p9.p1")}</p></li>
                <li><p className="paragraph">{t("policy.p9.p2")}</p></li>
            </ol>
            <p className="paragraph">{t("policy.p10")}</p>
            <p className="paragraph">{t("policy.p11")}</p>
            <p className="paragraph">{t("policy.p12")}</p>
            <p className="paragraph">{t("policy.p13")}</p>
        </div>
    )
}

export default Policy